import { Button, Text } from '@southfields-digital/mxmz-react-ui';

import styles from './RundownSettings.module.scss';
import { LAYOUTS, LayoutDefinition } from 'src/config/layouts';
import { useRundownLayout } from './useRundownLayout';

type RundownLayoutTogglesProps = {
  onClose: () => void;
  filterLayouts?: (item: LayoutDefinition) => boolean;
};

export function RundownLayoutToggles({ onClose, filterLayouts }: RundownLayoutTogglesProps) {
  const { layout, setLayout } = useRundownLayout();

  const availableLayouts = LAYOUTS.filter((item) => {
    if ((!layout && item.key === 'default') || layout === item.key) return false;
    return filterLayouts?.(item) ?? true;
  });

  return (
    <>
      {availableLayouts.map(({ key, label }) => (
        <li key={key}>
          <Button
            as="button"
            variant="tertiary"
            iconProps={{ size: 24, icon: 'repeat', weight: 'regular' }}
            onClick={() => {
              setLayout(layout === key ? null : key);
              onClose();
            }}
            className={styles.Button}
          >
            <Text as="span">{label}</Text>
          </Button>
        </li>
      ))}
    </>
  );
}
